import $ from 'jquery';

function CommonCtrl() {
	this.$win = $(window);
	this.$doc = $(document);
	this.$body = $('body');

	this.$editor = $('.information-content');

	this.editor = this.post_iframe.bind(this);

	this.init();
}

CommonCtrl.prototype.init = function () {
  // this.$win.on('load', this.post_iframe);
  this.post_iframe();
};


CommonCtrl.prototype.post_iframe = function () {
  this.$editor.find('iframe').each(function () {
    if ($(this).hasClass('wp-embedded-content')) {
      return true;
    }
    var iframeWidth = $(this).attr('width');
    var iframeHeight = $(this).attr('height');
    var ratio = iframeHeight / iframeWidth * 100;
    $(this).wrap('<div class="iframe" style="width:'+iframeWidth+'px;"><div class="iframe-inner" style="padding-bottom:'+ratio+'%;"></div></div>');
  });
}

export default CommonCtrl;
